import { useTranslation } from 'react-i18next';
import { extractLinks } from '../../../helpers/string-helpers/string-helpers';
import { useStrategyStore } from '../../../store/strategy-store/strategy-store';
import { Link } from '../../../ui-library/link/link';
import { Text } from '../../../ui-library/typography/typography';
import { StyledModal } from '../initiative-modal/initiative-modal';
import { ReactNode } from 'react';

type Props = {
  opened: boolean;
  onClose: () => void;
};

export const InitiativePerformanceModal = ({ opened, onClose }: Props) => {
  const i18n = useTranslation();
  const initiative = useStrategyStore((state) => state.initiativePerformance);

  if (!initiative) {
    return null;
  }

  const renderTextWithLinks = (text: string): ReactNode => {
    const linkWords = extractLinks(text);

    return linkWords.map((linkWord, index) => {
      if (linkWord.link) {
        return (
          <Link key={index} href={linkWord.word}>
            {linkWord.word}
          </Link>
        );
      } else {
        return <span key={index}>{linkWord.word}</span>;
      }
    });
  };

  return (
    <StyledModal
      opened={opened}
      onClose={onClose}
      title={
        <Text size="large" weight="bold" style={{ maxWidth: 600 }}>
          {initiative.name}
        </Text>
      }
      size={800}
      centered
    >
      <Text style={{ whiteSpace: 'pre-wrap' }}>
        {initiative.description
          ? renderTextWithLinks(initiative.description)
          : i18n.t('strategy.initiatives.no_description')}
      </Text>
    </StyledModal>
  );
};
